import { render, staticRenderFns } from "./PromoSlides.vue?vue&type=template&id=5dc3b278&scoped=true"
import script from "./PromoSlides.vue?vue&type=script&lang=js"
export * from "./PromoSlides.vue?vue&type=script&lang=js"
import style0 from "./PromoSlides.vue?vue&type=style&index=0&id=5dc3b278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc3b278",
  null
  
)

export default component.exports